module.exports = __webpack_public_path__ + "static/media/logo-skype.2ff8f84c.svg";